import { Box } from "@mui/material";
import { MOBILE_BREAKPOINT } from "@/styles/responsive";
import { mock } from "./Panel";

interface Props {
  steps: string[];
  active: number;
}

/**
 * モックの .stepper。MUI の Stepper は丸の大きさ・今のステップの影・線の太さが
 * モックと合わず、上書きが多くなるため自前で描く
 */
export const FlowStepper = ({ steps, active }: Props): JSX.Element => (
  <Box
    component="ol"
    aria-label="進捗"
    sx={{
      display: "flex",
      alignItems: "flex-start",
      maxWidth: 760,
      width: "100%",
      mx: "auto",
      my: 0,
      p: 0,
      listStyle: "none",
    }}
  >
    {steps.map((label, index) => {
      const done = index < active;
      const current = index === active;
      return (
        <Box
          component="li"
          key={label}
          aria-current={current ? "step" : undefined}
          sx={{
            flex: 1,
            position: "relative",
            textAlign: "center",
            fontSize: { xs: 12, [MOBILE_BREAKPOINT]: 13 },
            fontWeight: 700,
            color: done || current ? mock.tealDark : "#9ca3a6",
            "&:not(:last-of-type)::after": {
              content: '""',
              position: "absolute",
              top: 15,
              left: "calc(50% + 22px)",
              width: "calc(100% - 44px)",
              height: 2,
              bgcolor: done ? mock.teal : "#dfe4e6",
            },
          }}
        >
          <Box
            sx={{
              width: 31,
              height: 31,
              mx: "auto",
              mb: "7px",
              display: "grid",
              placeItems: "center",
              borderRadius: "50%",
              border: "2px solid",
              borderColor: done || current ? mock.teal : "#cfd5d7",
              bgcolor: done || current ? mock.teal : "#fff",
              color: done || current ? "#fff" : "inherit",
              boxShadow: current ? `0 0 0 4px ${mock.tealSoft}` : "none",
            }}
          >
            {done ? "✓" : index + 1}
          </Box>
          {label}
        </Box>
      );
    })}
  </Box>
);
